// used internally to denote the default collection ID
export const DEFAULT_COLLECTION_ID = '0';

export const LOCAL_STORAGE_SURL_KEY = 'surl';
export const LOCAL_STORAGE_CSRF_TOKEN = 'token';
export const LOCAL_STORAGE_LOCALE_KEY = 'locale';
export const LOCAL_STORAGE_EXTERNAL_LOGIN = 'PICTION_LOGIN';
export const LOCAL_STORAGE_EXT_URL = 'PICTION_EXT_URL';
export const LOCAL_STORAGE_EXT_SEARCH = 'PICTION_SEARCH';



// WEBPACK FOOTER //
// ./src/js/constants/session.js